module.exports = {
	"pagination": {
		"ListBatchInferenceJobs": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "batchInferenceJobs"
		},
		"ListBatchSegmentJobs": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "batchSegmentJobs"
		},
		"ListCampaigns": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "campaigns"
		},
		"ListDatasetExportJobs": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "datasetExportJobs"
		},
		"ListDatasetGroups": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "datasetGroups"
		},
		"ListDatasetImportJobs": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "datasetImportJobs"
		},
		"ListDatasets": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "datasets"
		},
		"ListEventTrackers": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "eventTrackers"
		},
		"ListFilters": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "Filters"
		},
		"ListMetricAttributionMetrics": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "metrics"
		},
		"ListMetricAttributions": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "metricAttributions"
		},
		"ListRecipes": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "recipes"
		},
		"ListRecommenders": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "recommenders"
		},
		"ListSchemas": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "schemas"
		},
		"ListSolutionVersions": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "solutionVersions"
		},
		"ListSolutions": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "solutions"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/personalize-2018-05-22.paginators.json
// module id = 2193
// module chunks = 0